import BidCheckmarkIcon from '../BidCheckmarkIcon/BidCheckmarkIcon'

export default function BidWinningLabel({ children = 'Winning' }) {
  return (
    <div
      className="flex w-max py-1.5 px-2 border border-bidfta-green
            text-12 md:text-10 text-bidfta-green bg-white font-semibold
            items-center"
    >
      <BidCheckmarkIcon />
      <span className="block pl-1">{children}</span>
    </div>
  )
}
